// extracted by mini-css-extract-plugin
export default {"carousel":"ReviewCarousel_carousel__+0bxr","item":"ReviewCarousel_item__DSZm1","review":"ReviewCarousel_review__5rsf5"};